import Typography from '@mui/material/Typography';
import { AvailableTimes } from '../../../interfaces';

type Props = {
  time: AvailableTimes;
  onChange: (value: Date) => void;
  closeModal: any;
};

export default function Time({ time, onChange, closeModal }: Props) {
  const dateTime = new Date(time.startDateTime);

  function clickHandle(datetime: Date) {
    onChange(datetime);
    closeModal();
  }

  return (
    <div
      role="presentation"
      className="time-item"
      onClick={() => {
        clickHandle(dateTime);
      }}>
      <Typography variant="h3">{time.displayTime}</Typography>
    </div>
  );
}
